import React from 'react'

import { Link } from 'react-router-dom'

import { PlainTextButton, ButtonProps, makeAppStyles } from '@percept/mui'
import { ChevronRight, Schedule } from '@percept/mui/icons'


export type LinkButtonProps = (
  Omit<ButtonProps, 'onClick'> & {
    to: string
    size?: 'small' | 'large'
    dummy?: boolean
    comingSoon?: boolean
    openInNewWindow?: boolean
  }
)


const useStyles = makeAppStyles( theme => ({
  button: {
    height: 62,
    fontSize: 22,
    justifyContent: 'space-between',
  },
  buttonSmall: {
    height: 28,
    fontSize: 15,
    justifyContent: 'space-between',
  },
  disabled: {
    color: theme.palette.text.disabled,
  },
  endIcon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(0.5),
    fontSize: '27px !important',
    borderRadius: '100%',
    stroke: 'none',
  },
  endIconSmall: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(0.25),
    fontSize: '18px !important',
    borderRadius: '100%',
    stroke: 'none',
  },
  active: {
    color: theme.palette.primary.main,
    backgroundColor: 'white',
  }
}))


export const LinkButton = ({
  to,
  children = 'Show me more',
  className = '',
  size = 'large',
  dummy = false,
  openInNewWindow = false,
  comingSoon = false,
  ...props
}: LinkButtonProps): JSX.Element => {
  const classes = useStyles()

  let buttonClassName = classes.button
  let endIconClassName = classes.endIcon
  if( size === 'small' ){
    buttonClassName = classes.buttonSmall
    endIconClassName = classes.endIconSmall
  }
  if( comingSoon ){
    buttonClassName += (' ' + classes.disabled)
  }
  if( !openInNewWindow ){
    buttonClassName += (' ' + className)
  }

  const buttonProps: ButtonProps = comingSoon ? {
    color: 'default',
    endIcon: <Schedule className={endIconClassName} />
  } : {
    endIcon: <ChevronRight className={`${endIconClassName} ${classes.active}`} />
  }

  children = comingSoon ? 'Coming soon' : children

  const button = (
    <PlainTextButton
      className={buttonClassName}
      variant='contained'
      color='primary'
      size={size}
      {...buttonProps}
      {...props}>
      { children }
    </PlainTextButton>
  )

  if( dummy ){
    return button
  }

  if( openInNewWindow ){
    return (
      <a
        className={className}
        href={to}
        target='_blank'
        rel='noopener noreferrer'>
        { button }
      </a>
    )
  }

  return (
    <Link
      to={to}>
      { button }
    </Link>
  )
}
